module.exports = __webpack_public_path__ + "static/media/Group 59@2x.3721b663.png";